import React, { useMemo, useState, useEffect } from 'react'
import BigNumber from 'bignumber.js'
import styled, { keyframes } from 'styled-components'
import { Flex, Text, Skeleton } from '@pancakeswap-libs/uikit'
import { communityFarms } from 'config/constants'
import { Farm } from 'state/types'
import { usePriceCakeBusd, usePriceContract, usePriceBnbbyPid } from 'state/hooks'
import { provider as ProviderType } from 'web3-core'
import useI18n from 'hooks/useI18n'
import ExpandableSectionButton from 'components/ExpandableSectionButton'
import { BASE_ADD_LIQUIDITY_URL } from 'config'
import getLiquidityUrlPathParts from 'utils/getLiquidityUrlPathParts'
import { getMasterChefAddress } from 'utils/addressHelpers'
import DetailsSection from './DetailsSection'
import CardHeading from './CardHeading'
import CardActionsContainer from './CardActionsContainer'
import ApyButton from './ApyButton'

export interface FarmWithStakedValue extends Farm {
  apy?: number
  liquidity?: BigNumber
}

const RainbowLight = keyframes`
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
`

const StyledCardAccent = styled.div`
  background: linear-gradient(
    45deg,
    rgba(255, 0, 0, 1) 0%,
    rgba(255, 154, 0, 1) 10%,
    rgba(208, 222, 33, 1) 20%,
    rgba(79, 220, 74, 1) 30%,
    rgba(63, 218, 216, 1) 40%,
    rgba(47, 201, 226, 1) 50%,
    rgba(28, 127, 238, 1) 60%,
    rgba(95, 21, 242, 1) 70%,
    rgba(186, 12, 248, 1) 80%,
    rgba(251, 7, 217, 1) 90%,
    rgba(255, 0, 0, 1) 100%
  );
  background-size: 300% 300%;
  animation: ${RainbowLight} 2s linear infinite;
  border-radius: 32px;
  filter: blur(6px);
  position: absolute;
  top: -2px;
  right: -2px;
  bottom: -2px;
  left: -2px;
  z-index: -1;
`

const FCard = styled.div`
  align-self: baseline;
  background: ${(props) => props.theme.card.background};
  border-radius: 32px;
  box-shadow: 0px 2px 12px -8px rgba(25, 19, 38, 0.1), 0px 1px 1px rgba(25, 19, 38, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 24px;
  position: relative;
  text-align: center;
`

const Divider = styled.div`
  background-color: ${({ theme }) => theme.colors.borderColor};
  height: 1px;
  margin: 28px auto;
  width: 100%;
`

const ExpandingWrapper = styled.div<{ expanded: boolean }>`
  height: ${(props) => (props.expanded ? '100%' : '0px')};
  overflow: hidden;
`

interface FarmCardProps {
  farm: FarmWithStakedValue
  removed: boolean
  cakePrice?: BigNumber
  provider?: ProviderType
  account?: string
}

const FarmCard: React.FC<FarmCardProps> = ({ farm, removed, cakePrice, account }) => {
  const TranslateString = useI18n()

  const [showExpandableSection, setShowExpandableSection] = useState(false)

  const isCommunityFarm = communityFarms.includes(farm.token.symbol)
  // We assume the token name is coin pair + lp e.g. CAKE-BNB LP, LINK-BNB LP,
  // NAR-CAKE LP. The images should be cake-bnb.svg, link-bnb.svg, nar-cake.svg
  const farmImage = farm.lpSymbol.split(' ')[0].toLocaleLowerCase()



    const newFarmApy = farm.apy;
    const newLiquidity = farm.liquidity;
/*
      const verifi = `${farm.lpSymbol} : ${farm.apy}`;
      console.log(verifi)    

    if(farm.apy === null){

      // newFarmApy = Math.floor(Math.random() * 7000000) + 3000000;
      if(farm.lpSymbol === "ZEFI-ZBO LP"){
        newFarmApy = 43976709;
      }
      if(farm.lpSymbol === "ZBO-BNB LP"){
        newFarmApy = 14658903;
      }      
      newLiquidity = new BigNumber(0);
    }

*/

  const totalValueFormated = newLiquidity
    ? `$${newLiquidity.toNumber().toLocaleString(undefined, { maximumFractionDigits: 0 })}`
    : '-'

  const lpLabel = farm.lpSymbol && farm.lpSymbol.toUpperCase().replace('ZEFI', 'ZEFI')
  const version = farm.version
  const earnLabel = farm.dual ? farm.dual.earnLabel : 'ZEFI'

  const farmAPY = newFarmApy && newFarmApy.toLocaleString('en-US', { maximumFractionDigits: 2 })

  const liquidityUrlPathParts = getLiquidityUrlPathParts({
    quoteTokenAddress: farm.quoteToken.address,
    tokenAddress: farm.token.address,
  })
  const addLiquidityUrl = `https://exchange.zcore.network/#/swap?inputCurrency=BNB&outputCurrency=${farm.token.address[process.env.REACT_APP_CHAIN_ID]}`






  let stakedBalance;
  if(farm.userData){
    stakedBalance = farm.userData.stakedBalance;
  }else{
    stakedBalance = new BigNumber(0);
  }

  let tokenPriceVsQuote;
  if(farm.tokenPriceVsQuote){
    tokenPriceVsQuote = farm.tokenPriceVsQuote;
  }else{
    tokenPriceVsQuote = new BigNumber(0);
  }

  let earnings;
  if(farm.userData){
    earnings = farm.userData.earnings;
  }else{
    earnings = new BigNumber(0);
  }  

  const divFarm = 2
  // if(farm.isTokenOnly){
  //  divFarm = 1
  // }    


/*
  const myLP: BigNumber = useMemo(() => {

    let tempprice = new BigNumber(0);
    if(stakedBalance > 0){
      if (quoteTokenSymbol === QuoteToken.BNB) {
        tempprice = new BigNumber(tokenPriceVsQuote * stakedBalance * divFarm * bnbPrice.toNumber())
      }else if (quoteTokenSymbol === QuoteToken.CAKE) {
        tempprice = new BigNumber(tokenPriceVsQuote * stakedBalance * divFarm * cakePrice.toNumber())
      }else if (quoteTokenSymbol === QuoteToken.ZEFI) {
        tempprice = new BigNumber(tokenPriceVsQuote * stakedBalance * divFarm * cakePrice.toNumber())
      }else{
        tempprice = new BigNumber(1 * stakedBalance * divFarm)
      }      
    }else{
      tempprice = new BigNumber(0)
    }

    return tempprice;
    
  }, [tokenPriceVsQuote, stakedBalance, quoteTokenSymbol, bnbPrice, cakePrice, divFarm])
*/

  const myEarning: BigNumber = useMemo(() => {
    return new BigNumber(cakePrice.toNumber() * earnings)
  }, [earnings, cakePrice])  


  const myEarningFormated = myEarning
    ? `$${Number(myEarning.toNumber()/1000000000000000000).toLocaleString(undefined, { maximumFractionDigits: 0 })}`
    : '-'  


  let mystaked = 0
  let tokenA = 0
  let tokenB = 0


const dataTokenAddress = farm.token.address[process.env.REACT_APP_CHAIN_ID]
const dataQuoteTokenAddress = farm.quoteToken.address[process.env.REACT_APP_CHAIN_ID]
const dataLPAddress = farm.lpAddresses[process.env.REACT_APP_CHAIN_ID]

const zefiStatus = usePriceContract(dataTokenAddress, dataQuoteTokenAddress, dataLPAddress)
// console.log ( JSON.stringify(zefiStatus) )


/*
const masterChefContract = getMasterChefAddress()
const [historyData, setHistoryData] = useState(0)
  useEffect(() => {
    if(stakedBalance > 0 && historyData === 0){
    fetch(`https://api.bscscan.com/api?module=account&action=tokenbalance&contractaddress=${farm.lpAddresses[process.env.REACT_APP_CHAIN_ID]}&address=${masterChefContract}`)
      .then((response) => response.json())
      .then((data) => setHistoryData(data.result))
      .catch(() => {
        setHistoryData(0)
      })
      // console.log('CALL!')
    }else{
       setHistoryData(historyData)
    }
  }, [stakedBalance, farm, account, masterChefContract, historyData])
*/



  

    if(stakedBalance > 0 && zefiStatus !== null){  


    const totLP = zefiStatus.lpTotalSupply
    const totMC = zefiStatus.lpTokenBalanceMC
    
    tokenA = stakedBalance/1000000000000000000 * (zefiStatus.tokenBalanceLP / zefiStatus.lpTotalSupply)
    tokenB = stakedBalance/1000000000000000000 * (zefiStatus.quoteTokenBlanceLP / zefiStatus.lpTotalSupply)
    
    const ntotalValue = new BigNumber(farm.liquidity)
    // mystaked = (ntotalValue.toNumber() * (stakedBalance/1000000000000000000) / (totMC))
    mystaked = (zefiStatus.thisPrice * (stakedBalance/1000000000000000000))


    // const ntotalValue = new BigNumber(farm.liquidity)
    // mystaked = (ntotalValue.toNumber() * (stakedBalance/1000000000000000000) / (historyData/1000000000000000000))


/*
    console.log('==============================')
    console.log(farm.lpSymbol)
    console.log(farm.lpAddresses[process.env.REACT_APP_CHAIN_ID])
    console.log(ntotalValue.toNumber())
    console.log(historyData/1000000000000000000)
    console.log(stakedBalance/1000000000000000000)
    console.log(mystaked)
    console.log('==============================')
*/    
  }


  const myLPFormated = mystaked
    ? `$${mystaked.toFixed(2)}`
    : '-'   



  return (
    <FCard>
      {farm.token.symbol === 'ZEFI' && <StyledCardAccent />}
      <CardHeading
        lpLabel={lpLabel}
        multiplier={farm.multiplier}
        isCommunityFarm={isCommunityFarm}
        farmImage={farmImage}
        tokenSymbol={farm.token.symbol}
        depositFee={farm.depositFeeBP}        
        version={version}
      />
      {!removed && (
        <Flex justifyContent="space-between" alignItems="center">
          <Text>{TranslateString(736, 'APR')}:</Text>
          <Text bold style={{ display: 'flex', alignItems: 'center' }}>
            {newFarmApy ? (
              <>
                <ApyButton lpLabel={lpLabel} addLiquidityUrl={addLiquidityUrl} cakePrice={cakePrice} apy={newFarmApy} />
                {farmAPY}%
              </>
            ) : (
              <Skeleton height={24} width={80} />
            )}
          </Text>
        </Flex>
      )}
      <Flex justifyContent="space-between">
        <Text>{TranslateString(318, 'Earn')}:</Text>
        <Text bold>{earnLabel}</Text>
      </Flex>
      <Flex justifyContent="space-between">
        <Text style={{ fontSize: '24px' }}>Deposit Fee:</Text>
        <Text bold style={{ fontSize: '24px' }}>
          {farm.depositFeeBP / 100}%
        </Text>
      </Flex>      
      <CardActionsContainer farm={farm} account={account} addLiquidityUrl={addLiquidityUrl} />
      <Divider />
      <ExpandableSectionButton
        onClick={() => setShowExpandableSection(!showExpandableSection)}
        expanded={showExpandableSection}
      />
      <ExpandingWrapper expanded={showExpandableSection}>
        <DetailsSection
          removed={removed}
          bscScanAddress={`https://bscscan.com/address/${farm.token.address[process.env.REACT_APP_CHAIN_ID]}`}
          totalValueFormated={totalValueFormated}
          lpLabel={lpLabel}
          addLiquidityUrl={addLiquidityUrl}
          myEarning={myEarningFormated}
          myLP={myLPFormated}          
        />
      </ExpandingWrapper>
    </FCard>
  )
}

export default FarmCard
